// UI strings for a lesson check's stress item on an inflected form (exercises/items.ts
// stressFormItem; lesson 1: the commands kelītīs, memēbātās, Halme h1-i-003). Finnish first.
import { defineArea } from '../area';

export const stressFormsFi = {
  /** Under the question when the form is a command (final stress). */
  command: 'Sana on käsky.',
};

export const stressFormsEn: typeof stressFormsFi = {
  command: 'The word is a command.',
};

// Messages.stressForms (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('stressForms', stressFormsFi, stressFormsEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof stressFormsFi> {}
}
